import { Component, Input, EventEmitter, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faTrashCan } from '@fortawesome/pro-solid-svg-icons';

import { SystemMessageService } from '../../../../core/system-message/system-message-service';
import { SecurityService } from '../../../../core/security/security.service';
import { TableComponent } from '../../table.component';
import { param } from '../../../http-params';
import { AlertModalService } from './../../../form-elements/components/alert-modal/alert-modal.service';
import { DeleteCommentModalComponent } from './delete-comment-modal/delete-comment-modal.component';

@Component({
    selector: 'pcg-delete-button'
    , templateUrl: './delete-button.component.html'
    , styleUrls: ['./delete-button.component.scss']
    , standalone: false
})
export class DeleteButtonComponent<T> {

    ms = inject(SystemMessageService);
    alertModalService = inject(AlertModalService);
    public router = inject(Router);
    public modalService = inject(NgbModal);
    sec = inject(SecurityService);

    // S2N-3076: a delete is a write the server refuses for View Only, so render nothing (button
    // or icon variant) here rather than gating every list that hosts this component.
    readonly isViewOnly = this.sec.isViewOnly();

	@Input() url!: string;
	@Input() id!: string;
	@Input() confirmMessage = 'Are you sure you want to delete this?';
	@Input() isUsingComment = false;
	@Input() bypassConfirmMessage = false;
	@Input() table!: TableComponent<T>;
	@Input() iconView: boolean = false;
	@Input() deletingActiveUser: boolean = false;
    @Input() urlWithoutStupidCustomCodeForQueryParams!: string;
    @Input() returnUrl = "";

	@Output() delete = new EventEmitter<any>();

	deleteComment = "";

	faIconName = { faTrashCan };

	noDeleteMessage = false;

	deleteRecord() {
		if (
			this.bypassConfirmMessage === true 
			|| !this.confirmMessage
		) { this.executeDelete(); } 
		else if (this.deletingActiveUser){ this.executeDelete(); } 
        else {
            this.alertModalService.openAlert(
                this.confirmMessage
                , () => { this.executeDelete(); }
            );
        }
	}
	
	executeDelete() {
		const idQueryStr = typeof this.id === 'string' || typeof this.id === 'number'
            ? 'id=' + encodeURIComponent(this.id)
            : param(this.id);

        if (
            this.urlWithoutStupidCustomCodeForQueryParams == null 
            || this.urlWithoutStupidCustomCodeForQueryParams == ""
        ) {
            this.ms.getHttpObservable(this, this.url + '?' + idQueryStr)
                .subscribe(obj => {
                    this.delete.emit(obj);
                    if (this.table) { this.table.ajaxReload(); }
                    else if (this.returnUrl) { this.router.navigateByUrl(this.returnUrl); }
                }
            );
        } else {
            this.ms.getHttpObservable(this, this.urlWithoutStupidCustomCodeForQueryParams)
                .subscribe(obj => {
                    this.delete.emit(obj);
                    if (this.table) { this.table.ajaxReload(); }
                    else if (this.returnUrl) { this.router.navigateByUrl(this.returnUrl); }
                }
            );
        }
		
	}
	
	deleteWithComment() {
		if (this.deleteComment?.length == 0) {
			this.noDeleteMessage = true;
			return 
		}
		let idQueryStr = typeof this.id === 'string' || typeof this.id === 'number'
            ? 'id=' + encodeURIComponent(this.id)
            : param(this.id);
		idQueryStr += `&comment=${encodeURIComponent(this.deleteComment)}`;
		this.ms.getHttpObservable(this, this.url + '?' + idQueryStr)
            .subscribe(obj => {
                this.delete.emit(obj);				
                if (this.table) { 
                    this.table.ajaxReload(); 
                    this.modalService.dismissAll();
                } else if (this.returnUrl) { this.router.navigateByUrl(this.returnUrl); }
            }
        );
	}
	
	openModal() {
		const modalRef = this.modalService.open(DeleteCommentModalComponent);
		modalRef.componentInstance.deleteComment = this.deleteComment; 
	
		modalRef.result.then(
			(result) => {
				if (result) {
					this.deleteComment = result;
					this.deleteWithComment();
				}
			}
		);
	}
}
